import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormControl, Validators, AbstractControl } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';

import { SessionService } from '../../session.service';

@Component({
  selector: 'app-password-reset',
  templateUrl: './password-reset.component.html',
  styleUrls: ['./password-reset.component.css'],
  standalone: false,
})
export class PasswordResetComponent implements OnInit {

  oobCode?: string;
  password?: string;
  comfirm_password?: string;

  editForm : FormGroup;
  adminIdControl!: FormControl;
  passwordControl!: FormControl;
  comfirmPasswordControl!: FormControl;

  constructor(
    private formBuilder: FormBuilder,
    private sessionService: SessionService,
    private route: ActivatedRoute,
  ) {
    this.editForm = this.formBuilder.group({
      password: [this.password, [Validators.required, Validators.minLength(10), Validators.pattern('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])[a-zA-Z0-9]*$')]],
      comfirm_password: [this.comfirm_password, [Validators.required, Validators.minLength(10), Validators.pattern('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])[a-zA-Z0-9]*$')]],
    }, {
      validator: this.checkSame,
    });
  }

  ngOnInit(): void {
    this.route.queryParamMap.subscribe((params) => {
      this.oobCode = params.get('oobCode') || '';
    });
    this.passwordControl = this.editForm.get('password') as FormControl;
    this.comfirmPasswordControl = this.editForm.get('comfirm_password') as FormControl;
  }

  // パスワードと確認パスワード同一チェック
  checkSame(ac: AbstractControl) {
    const password = ac.get('password');
    const comfirm_password = ac.get('comfirm_password');
    if (!comfirm_password?.errors) {
      if (!!password && !!comfirm_password) {
        if (password.value != comfirm_password.value) {
          comfirm_password.setErrors({ checkSame: true });
        } else {
          comfirm_password?.setErrors(null);
        }
      }
    }
  }

  passwordReset(): void {
    if (this.oobCode) {
      this.sessionService.passwordReset(this.oobCode, this.passwordControl.value);
    }
  }
  //以下、フォームの記入エラー表示
  public getErrorMessageToPassword() {
    return this.passwordControl.hasError('required')
    ? '必須項目'
    : this.passwordControl.hasError('minlength')
    ? '１０文字以上'
    : this.passwordControl.hasError('pattern')
    ? '半角英小文字大文字数字をそれぞれ１種類以上含む'
    : '';
  }
  public getErrorMessageToComfirmPassword() {
    return this.comfirmPasswordControl.hasError('required')
    ? '必須項目'
    : this.comfirmPasswordControl.hasError('minlength')
    ? '１０文字以上'
    : this.comfirmPasswordControl.hasError('pattern')
    ? '半角英小文字大文字数字をそれぞれ１種類以上含む'
    : this.comfirmPasswordControl.hasError('checkSame')
    ? 'パスワードが異なります'
    : '';
  }
}
